import { instantMeiliSearch } from '@meilisearch/instant-meilisearch'
import { MeiliSearchConfig } from './config'
import {
  SearchClient,
  SearchQuery,
  SearchResponse,
  SearchResult,
} from './types'

// Store Search client locally so we don't have to recreate it every time
let searchClient: SearchClient | null = null

/**
 * Search client for MeiliSearch instance
 * @param meiliConfig Object containing MeiliSearch configuration.
 * @param meiliConfig.url The URL of the MeiliSearch instance.
 * @param meiliConfig.apiKey The API key for MeiliSearch.
 */
export function getSearchClient(meiliConfig: MeiliSearchConfig): SearchClient {
  if (!searchClient) {
    const url = meiliConfig.url
    const apiKey = meiliConfig.apiKey
    searchClient = instantMeiliSearch(url, apiKey, {
      placeholderSearch: false,
      primaryKey: 'id',
      meiliSearchParams: {
        attributesToCrop: ['searchableBody'],
        cropLength: 10,
      },
    }).searchClient as SearchClient
  }

  return searchClient
}

/**
 * get results from the search client
 * @param meiliConfig Object containing MeiliSearch configuration.
 * @param meiliConfig.url The URL of the MeiliSearch instance.
 * @param meiliConfig.apiKey The API key for MeiliSearch.
 * @param query The search query string.
 * @param indexName The name of the index to search.
 * @param highlightSplitTag The tag used for highlighting search results.
 */
export async function getResults(
  meiliConfig: MeiliSearchConfig,
  query: string,
  indexName: string,
  highlightSplitTag: string
): Promise<SearchResult[]> {
  const payload: SearchQuery[] = [
    {
      indexName,
      params: {
        analytics: false,
        'attributes-to-snippet': ['searchableBody'],
        distinct: true,
        enablePersonalization: true,
        highlightPostTag: highlightSplitTag,
        highlightPreTag: highlightSplitTag,
        hitsPerPage: 10,
        query: query,
      },
    },
  ]

  // @ts-ignore - hits do exist
  const res: SearchResponse = await getSearchClient(meiliConfig).search(payload)
  return res.results[0].hits
}
